import { render, staticRenderFns } from "./TerminalStamp.vue?vue&type=template&id=64930a08&scoped=true"
import script from "./TerminalStamp.vue?vue&type=script&lang=js"
export * from "./TerminalStamp.vue?vue&type=script&lang=js"
import style0 from "./TerminalStamp.vue?vue&type=style&index=0&id=64930a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64930a08",
  null
  
)

export default component.exports